import Layout from '@/components/layout/Layout.vue'
import { getMediaAdvertiserStats, getMediaCampaignStats, getMediaWorkerStats, getRecentMediaCampaigns, closeCampaigns, enableCampaigns, getAdvertiserCampaignsCount, closeAllAdvertiserCampaigns, enableAllAdvertiserCampaigns } from '@/api/media-advertiser-stat'
import { getWorkers} from '@/api/open'
import moment from 'moment'

const pageName = 'media_advertiser_stats'

export default {
    name: pageName,
    components: { Layout },
    data() {
        return {
            activeTab: 'advertiser',
            platforms: [],
            summary: {},
            campaignSummary: {},
            workerSummary: {},
            // 报表统计时间按 Tab 独立保存，切换 Tab 时各 Tab 保留自己的时间区间
            tabDateRange: {},
            recentCampaignNotice: '',
            workers: [],
            advertiser_ids: '',
            sum_cost: 0,
            // 本次请求实际生效的报表统计区间，用于判断「按天累计 N 日 ROI」列是否展示
            activeDateRange: [],
            selectedCampaignRows: [],
            selectedAdvertiserRows: [],
            closeLoading: false,
            enableLoading: false,
            advertiserCloseLoading: false,
            advertiserEnableLoading: false,
            businessTypes: [{id:1, name:"快手分销"}, {id:2, name:"快手番茄代投"}],
            payTypes: [{id:1, name:"收费"}, {id:2, name:"免费"}],
            putStatusMap: {1: '投放中', 2: '已暂停', 3: '已删除', 4: '执行中'},
            putStatusColor: {1: 'green', 2: 'orange', 3: 'red', 4: 'blue'},
            queryParam: {
                page: 1,
                page_size: 20,
                advertiser_id: undefined,
                advertiser_name: undefined,
                campaign_id: undefined,
                campaign_name: undefined,
                worker_id: undefined,
                business_type: undefined,
                pay_type: undefined,
                started_at: moment().format('YYYY-MM-DD'),
                finished_at: moment().format('YYYY-MM-DD'),
                date: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
                campaign_created_started_at: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                campaign_created_finished_at: moment().format('YYYY-MM-DD'),
                campaign_created_date: [moment().subtract(1, 'month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
                sort_field: undefined,
                sort_type: undefined,
                put_status: undefined,
            },
            // 优化师报表：按优化师维度聚合，不展示广告主ID/名称等非必要字段
            workerColumns: [
                { minWidth: 120, title: '优化师', field: 'worker_id', fixed: 'left', formatter: item => {
                    return this.$helper.getItemName(this.workers, item.row.worker_id) || '-'
                }, ellipsis: true },
                { minWidth: 120, title: '花费(元)', field: 'charge', sortable: true },
                { minWidth: 180, title: '转化数(回传时间)', field: 'conversion_num', sortable: true },
                { minWidth: 180, title: '转化成本(回传时间)', field: 'conversion_num_cost', sortable: true },
                { minWidth: 180, title: 'IAA广告变现LTV', field: 'minigame_iaa_purchase_amount', sortable: true },
                { minWidth: 180, title: 'IAA广告变现ROI(%)', field: 'minigame_iaa_purchase_roi', sortable: true, type: 'html', formatter: item => { return '<span style="'+(item.row.minigame_iaa_purchase_roi >= 90 ?'color:red':'')+'">'+item.row.minigame_iaa_purchase_roi+'</span>' }},
                { minWidth: 120, title: '激活数', field: 'activation', sortable: true },
                { minWidth: 120, title: '激活单价', field: 'conversion_cost', sortable: true },
                { minWidth: 120, title: '付费金额', field: 'event_pay_purchase_amount', sortable: true },
                { minWidth: 120, title: 'ROI', field: 'event_pay_roi', sortable: true, type: 'html', formatter: item => { return '<span style="'+(item.row.event_pay_roi >= 95 ?'color:red':'')+'">'+item.row.event_pay_roi+'</span>' }},
                { minWidth: 120, title: '当日累计ROI', field: 'event_pay_first_day_roi', sortable: true },
                { minWidth: 120, title: '封面点击数', field: 'photo_click', sortable: true },
                { minWidth: 120, title: '播放数', field: 'played_num', sortable: true },
                { minWidth: 120, title: '行为数', field: 'bclick', sortable: true },
                { minWidth: 120, title: '封面曝光数', field: 'show', sortable: true },
                { minWidth: 140, title: '封面点击率(%)', field: 'photo_click_ratio', sortable: true },
                { minWidth: 120, title: '素材曝光数', field: 'aclick', sortable: true },
                { minWidth: 140, title: '素材点击率(%)', field: 'aclick_ratio', sortable: true },
                { minWidth: 200, title: '平均千次封面曝光花费(元)', field: 'impression_1k_cost', sortable: true },
                { minWidth: 200, title: '平均千次素材曝光花费(元)', field: 'click_1k_cost', sortable: true },
                { minWidth: 180, title: '平均封面点击单价(元)', field: 'photo_click_cost', sortable: true },
                { minWidth: 160, title: '平均行为单价(元)', field: 'action_cost', sortable: true },
                { minWidth: 120, title: '行为率(%)', field: 'action_ratio', sortable: true },
            ],
            advertiserColumns: [
                { type: 'checkbox', width: 50, fixed: 'left' },
                { minWidth: 180, title: '广告主ID', field: 'advertiser_id', fixed: 'left'},
                { minWidth: 100, title: '优化师', field: 'worker_id', fixed: 'left', formatter: item => {
                    return this.$helper.getItemName(this.workers, item.row.worker_id) || '-'
                }, ellipsis: true },
                { minWidth: 180, title: '广告主名称', field: 'advertiser_name'},
                { minWidth: 140, title: '产品名称', field: 'product_name', ellipsis: true },
                { minWidth: 140, title: '应用名称', field: 'app_name', ellipsis: true },
                { minWidth: 120, title: '花费(元)', field: 'charge', sortable: true },
                { minWidth: 180, title: '转化数(回传时间)', field: 'conversion_num', sortable: true },
                { minWidth: 180, title: '转化成本(回传时间)', field: 'conversion_num_cost', sortable: true },
                { minWidth: 180, title: 'IAA广告变现LTV', field: 'minigame_iaa_purchase_amount', sortable: true },
                { minWidth: 180, title: 'IAA广告变现ROI(%)', field: 'minigame_iaa_purchase_roi', sortable: true, type: 'html', formatter: item => { return '<span style="'+(item.row.minigame_iaa_purchase_roi >= 90 ?'color:red':'')+'">'+item.row.minigame_iaa_purchase_roi+'</span>' }},
                // 激活后 N 日广告变现 ROI：后端已按 激活后N日广告LTV / 消耗 * 100 计算，前端仅展示（计算列不支持排序）
                { minWidth: 200, title: '激活后三日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_three_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 200, title: '激活后七日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_week_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 200, title: '激活后15日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_15_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 200, title: '激活后30日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_30_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 120, title: '激活数', field: 'activation', sortable: true },
                { minWidth: 120, title: '激活单价', field: 'conversion_cost', sortable: true },
                { minWidth: 120, title: '付费金额', field: 'event_pay_purchase_amount', sortable: true },
                { minWidth: 120, title: 'ROI', field: 'event_pay_roi', sortable: true, type: 'html', formatter: item => { return '<span style="'+(item.row.event_pay_roi >= 95 ?'color:red':'')+'">'+item.row.event_pay_roi+'</span>' }},
                { minWidth: 120, title: '当日累计ROI', field: 'event_pay_first_day_roi', sortable: true },
                // 激活后 N 日付费 ROI：后端已按 激活后N日付费金额 / 消耗 * 100 计算，前端仅展示（计算列不支持排序）
                { minWidth: 140, title: '激活后3日ROI(%)', field: 'event_pay_purchase_amount_three_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 140, title: '激活后7日ROI(%)', field: 'event_pay_purchase_amount_week_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 140, title: '激活后15日ROI(%)', field: 'event_pay_purchase_amount_15_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 140, title: '激活后30日ROI(%)', field: 'event_pay_purchase_amount_30_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 120, title: '封面点击数', field: 'photo_click', sortable: true },
                { minWidth: 120, title: '播放数', field: 'played_num', sortable: true },
                { minWidth: 120, title: '行为数', field: 'bclick', sortable: true },
                { minWidth: 120, title: '封面曝光数', field: 'show', sortable: true },
                { minWidth: 140, title: '封面点击率(%)', field: 'photo_click_ratio', sortable: true },
                { minWidth: 120, title: '素材曝光数', field: 'aclick', sortable: true },
                { minWidth: 140, title: '素材点击率(%)', field: 'aclick_ratio', sortable: true },
                { minWidth: 200, title: '平均千次封面曝光花费(元)', field: 'impression_1k_cost', sortable: true },
                { minWidth: 200, title: '平均千次素材曝光花费(元)', field: 'click_1k_cost', sortable: true },
                { minWidth: 180, title: '平均封面点击单价(元)', field: 'photo_click_cost', sortable: true },
                { minWidth: 160, title: '平均行为单价(元)', field: 'action_cost', sortable: true },
                { minWidth: 120, title: '行为率(%)', field: 'action_ratio', sortable: true },
                { minWidth: 180, title: '操作', field: 'advertiser_actions', slots: { default: 'advertiser_actions' }, fixed: 'right' },
            ],
            // 「按天累计 N 日」IAA广告变现ROI：单日筛选时展示，父列 + 子列构成两级表头；窗口为 [T-N+1, T]
            cumulativeIaaRoiColumns: [
                {
                    title: 'IAA广告变现ROI',
                    field: 'iaa_cumulative_roi',
                    children: [
                        { minWidth: 110, title: '3日', field: 'iaa_cumulative_roi_3d' },
                        { minWidth: 110, title: '7日', field: 'iaa_cumulative_roi_7d' },
                        { minWidth: 110, title: '15日', field: 'iaa_cumulative_roi_15d' },
                        { minWidth: 110, title: '30日', field: 'iaa_cumulative_roi_30d' },
                    ],
                },
            ],
            // 「按天累计 N 日」ROI：单日筛选时展示，父列 + 子列构成两级表头；窗口为 [T-N+1, T]
            cumulativePayRoiColumns: [
                {
                    title: 'ROI',
                    field: 'pay_cumulative_roi',
                    children: [
                        { minWidth: 110, title: '3日', field: 'pay_cumulative_roi_3d' },
                        { minWidth: 110, title: '7日', field: 'pay_cumulative_roi_7d' },
                        { minWidth: 110, title: '15日', field: 'pay_cumulative_roi_15d' },
                        { minWidth: 110, title: '30日', field: 'pay_cumulative_roi_30d' },
                    ],
                },
            ],
            campaignColumns: [
                { type: 'checkbox', width: 50, fixed: 'left' },
                { minWidth: 180, title: '广告主ID', field: 'advertiser_id', fixed: 'left' },
                { minWidth: 180, title: '广告计划ID', field: 'campaign_id', fixed: 'left' },
                { minWidth: 180, title: '广告主名称', field: 'advertiser_name'},
                { minWidth: 140, title: '产品名称', field: 'product_name', ellipsis: true },
                { minWidth: 140, title: '应用名称', field: 'app_name', ellipsis: true },
                { minWidth: 200, title: '广告计划名称', field: 'campaign_name', ellipsis: true },
                { minWidth: 170, title: '创建时间', field: 'created_at' },
                { minWidth: 100, title: '计划状态', field: 'put_status', slots: { default: 'put_status_default' }, fixed: 'right' },
                { minWidth: 100, title: '优化师', field: 'worker_id', formatter: item => {
                    return this.$helper.getItemName(this.workers, item.row.worker_id) || '-'
                }, ellipsis: true },
                { minWidth: 120, title: '花费(元)', field: 'charge', sortable: true },
                { minWidth: 180, title: '转化数(回传时间)', field: 'conversion_num', sortable: true },
                { minWidth: 180, title: '转化成本(回传时间)', field: 'conversion_num_cost', sortable: true },
                { minWidth: 180, title: 'IAA广告变现ROI(%)', field: 'minigame_iaa_purchase_roi', sortable: true, type: 'html', formatter: item => { return '<span style="'+(item.row.minigame_iaa_purchase_roi >= 90 ?'color:red':'')+'">'+item.row.minigame_iaa_purchase_roi+'</span>' }},
                { minWidth: 180, title: 'IAA广告变现LTV', field: 'minigame_iaa_purchase_amount', sortable: true },
                // 激活后 N 日广告变现 ROI：后端已按 激活后N日广告LTV / 消耗 * 100 计算，前端仅展示（计算列不支持排序）
                // { minWidth: 200, title: '激活后三日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_three_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                // { minWidth: 200, title: '激活后七日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_week_by_conversion_roi', slots: { header: 'tooltip_header' } },
                // { minWidth: 200, title: '激活后15日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_15_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                // { minWidth: 200, title: '激活后30日广告变现ROI(%)', field: 'minigame_iaa_purchase_amount_30_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 120, title: '激活数', field: 'activation', sortable: true },
                { minWidth: 120, title: '激活单价', field: 'conversion_cost', sortable: true },
                { minWidth: 120, title: '付费金额', field: 'event_pay_purchase_amount', sortable: true },
                { minWidth: 120, title: 'ROI', field: 'event_pay_roi', sortable: true, type: 'html', formatter: item => { return '<span style="'+(item.row.event_pay_roi >= 95 ?'color:red':'')+'">'+item.row.event_pay_roi+'</span>' }},
                { minWidth: 120, title: '当日累计ROI', field: 'event_pay_first_day_roi', sortable: true },
                // 激活后 N 日付费 ROI：后端已按 激活后N日付费金额 / 消耗 * 100 计算，前端仅展示（计算列不支持排序）
                // { minWidth: 140, title: '激活后3日ROI(%)', field: 'event_pay_purchase_amount_three_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                // { minWidth: 140, title: '激活后7日ROI(%)', field: 'event_pay_purchase_amount_week_by_conversion_roi', slots: { header: 'tooltip_header' } },
                // { minWidth: 140, title: '激活后15日ROI(%)', field: 'event_pay_purchase_amount_15_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                // { minWidth: 140, title: '激活后30日ROI(%)', field: 'event_pay_purchase_amount_30_day_by_conversion_roi', slots: { header: 'tooltip_header' } },
                { minWidth: 120, title: '封面点击数', field: 'photo_click', sortable: true },
                { minWidth: 120, title: '播放数', field: 'played_num', sortable: true },
                { minWidth: 120, title: '行为数', field: 'bclick', sortable: true },
                { minWidth: 120, title: '封面曝光数', field: 'show', sortable: true },
                { minWidth: 140, title: '封面点击率(%)', field: 'photo_click_ratio', sortable: true },
                { minWidth: 120, title: '素材曝光数', field: 'aclick', sortable: true },
                { minWidth: 140, title: '素材点击率(%)', field: 'aclick_ratio', sortable: true },
                { minWidth: 200, title: '平均千次封面曝光花费(元)', field: 'impression_1k_cost', sortable: true },
                { minWidth: 200, title: '平均千次素材曝光花费(元)', field: 'click_1k_cost', sortable: true },
                { minWidth: 180, title: '平均封面点击单价(元)', field: 'photo_click_cost', sortable: true },
                { minWidth: 160, title: '平均行为单价(元)', field: 'action_cost', sortable: true },
                { minWidth: 120, title: '行为率(%)', field: 'action_ratio', sortable: true },
                { minWidth: 100, title: '操作', field: 'actions', slots: { default: 'actions' }, fixed: 'right' },
            ],
            tableMaxHeight: 600,
            tableGrid: this.$helper.tableGrid(pageName),
        }
    },
    computed: {
        currentColumns() {
            if (this.activeTab === 'campaign_list') {
                // 广告计划 tab 不展示产品名称、应用名称（数据源也不含应用名称）
                return this.campaignColumns
                    .filter(column => !['product_name', 'app_name'].includes(column.field))
                    .map(column => ({ ...column, sortable: false }))
            }

            if (this.activeTab === 'worker') {
                return this.workerColumns
            }

            if (this.activeTab === 'advertiser') {
                const columns = [...this.advertiserColumns]
                if (this.showCumulativeRoi) {
                    // 累计列紧跟各自的当日列：IAA广告变现ROI 放在 IAA广告变现ROI(%) 之后、ROI 放在 ROI 之后，
                    // 便于与当日值直接对比；按 field 定位，插入顺序不影响结果
                    const iaaIndex = columns.findIndex(column => column.field === 'minigame_iaa_purchase_roi')
                    columns.splice(iaaIndex + 1, 0, ...this.cumulativeIaaRoiColumns)

                    const roiIndex = columns.findIndex(column => column.field === 'event_pay_roi')
                    columns.splice(roiIndex + 1, 0, ...this.cumulativePayRoiColumns)
                }
                return columns
            }

            return this.campaignColumns
        },
        // 「按天累计 N 日」ROI 仅在广告主报表且「报表统计时间为单日」时展示：
        // 该日期即累计窗口的结束日，多日区间没有明确归属日
        showCumulativeRoi() {
            const range = this.activeDateRange
            if (this.activeTab !== 'advertiser' || !Array.isArray(range) || range.length !== 2) {
                return false
            }
            return range[0] === range[1]
        },
        // 报表统计时间读写当前 Tab 自己的区间，保证切换 Tab 时互不共享
        dateRange: {
            get() {
                return this.tabDateRange[this.activeTab] || this.defaultDateRange(this.activeTab)
            },
            set(val) {
                this.$set(this.tabDateRange, this.activeTab, val)
                this.queryParam.date = val
            }
        },
        defaultDate() {
            return this.dateRange.map(day => moment(day))
        },
        defaultCampaignCreatedDate() {
            return [
                moment().subtract(1, 'month'),
                moment()
            ]
        }
    },
    created() {
        getWorkers().then(res => { this.workers = res.data.list || {} })
        // 预置各 Tab 独立的报表统计时间，优化师报表默认上个月，其余默认当天
        ;['worker', 'advertiser', 'campaign', 'campaign_list'].forEach(tab => {
            this.$set(this.tabDateRange, tab, this.defaultDateRange(tab))
        })
        this.queryParam.date = this.tabDateRange[this.activeTab]
        // 初始即按默认统计区间确定列显隐，避免首屏多一次列重建
        this.activeDateRange = [...this.tabDateRange[this.activeTab]]
        this.tableGrid.columns = this.currentColumns
        this.tableGrid.footerMethod = this.footerMethod
        this.initData()
    },
    watch: {
        advertiser_ids(newVal) {
            this.queryParam.advertiser_id = newVal.replace(/\n/g, ',');
        },
        // 累计 ROI 列随「是否当天筛选」切换，需重新下发列配置，避免旧列残留或新列缺失
        showCumulativeRoi() {
            this.tableGrid.columns = this.currentColumns
        },
    },
    mounted() {
        this.calcTableHeight()
        window.addEventListener('resize', this.calcTableHeight)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calcTableHeight)
    },
    methods: {
        async initData() {
            this.fetchData()
        },
        calcTableHeight() {
            this.tableMaxHeight = window.innerHeight - 280
        },
        async fetchData() {
            this.tableGrid.loading = true
            try {
                const params = { ...this.queryParam }
                if (params.date && params.date.length === 2) {
                    params.started_at = params.date[0]
                    params.finished_at = params.date[1]
                }
                // 记录本次生效的报表统计区间，累计 ROI 列的显隐随后端计算口径同步切换
                this.activeDateRange = Array.isArray(params.date) ? [...params.date] : []
                if (params.campaign_created_date && params.campaign_created_date.length === 2) {
                    params.campaign_created_started_at = params.campaign_created_date[0]
                    params.campaign_created_finished_at = params.campaign_created_date[1]
                }
                delete params.date
                delete params.campaign_created_date
                if (this.activeTab === 'worker') {
                    // 优化师报表不展示广告主筛选项，避免其它 Tab 遗留的广告主条件隐藏生效
                    delete params.advertiser_id
                    delete params.advertiser_name
                }
                if (this.activeTab === 'campaign_list') {
                    delete params.sort_field
                    delete params.sort_type
                }

                params.page = this.tableGrid.pagerConfig.currentPage
                params.page_size = this.tableGrid.pagerConfig.pageSize

                if (this.activeTab === 'advertiser') {
                    const res = await getMediaAdvertiserStats(params)
                    this.tableGrid.data = (res.data.list && res.data.list) || []
                    this.tableGrid.pagerConfig.total = (res.data.total && res.data.total) || 0
                    this.summary = res.data.summary || {}
                    this.sum_cost = this.summary.charge || 0
                } else if (this.activeTab === 'worker') {
                    const res = await getMediaWorkerStats(params)
                    this.tableGrid.data = (res.data.list && res.data.list) || []
                    this.tableGrid.pagerConfig.total = (res.data.total && res.data.total) || 0
                    this.workerSummary = res.data.summary || {}
                    this.sum_cost = this.workerSummary.charge || 0
                } else if (this.activeTab === 'campaign') {
                    const res = await getMediaCampaignStats(params)
                    this.tableGrid.data = (res.data.list && res.data.list) || []
                    this.tableGrid.pagerConfig.total = (res.data.total && res.data.total) || 0
                    this.campaignSummary = res.data.summary || {}
                    this.sum_cost = this.campaignSummary.charge || 0
                } else {
                    const res = await getRecentMediaCampaigns(params)
                    this.tableGrid.data = (res.data.list && res.data.list) || []
                    this.tableGrid.pagerConfig.total = (res.data.total && res.data.total) || 0
                    this.recentCampaignNotice = res.data.notice || ''
                    this.sum_cost = 0
                }
            } catch (e) {
                console.error(e)
                this.summary = {}
                this.campaignSummary = {}
                this.workerSummary = {}
            } finally {
                this.tableGrid.loading = false
            }
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.fetchData()
        },
        reset() {
            // 重置仅恢复当前 Tab 的报表统计时间，不影响其他 Tab 已选区间
            const defaultRange = this.defaultDateRange(this.activeTab)
            this.$set(this.tabDateRange, this.activeTab, defaultRange)
            this.queryParam = {
                page: 1,
                page_size: 20,
                advertiser_id: undefined,
                advertiser_name: undefined,
                campaign_id: undefined,
                campaign_name: undefined,
                worker_id: undefined,
                business_type: undefined,
                pay_type: undefined,
                started_at: defaultRange[0],
                finished_at: defaultRange[1],
                date: defaultRange,
                campaign_created_started_at: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                campaign_created_finished_at: moment().format('YYYY-MM-DD'),
                campaign_created_date: [moment().subtract(1, 'month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
                sort_field: undefined,
                sort_type: undefined,
                put_status: undefined,
            }
            this.advertiser_ids = ''
            this.summary = {}
            this.campaignSummary = {}
            this.workerSummary = {}
            this.recentCampaignNotice = ''
            this.fetchData()
        },
        /**
         * 返回指定 Tab 的报表统计时间默认区间。
         * 优化师报表默认上个月（月初至月末），其他 Tab 默认当天。
         */
        defaultDateRange(tab) {
            const today = moment().format('YYYY-MM-DD')
            if (tab === 'worker') {
                return [
                    moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
                    moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
                ]
            }
            return [today, today]
        },
        onPageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.fetchData()
        },
        handleSortChange(data) {
            if (this.activeTab === 'campaign_list') {
                this.queryParam.sort_field = null
                this.queryParam.sort_type = null
                return
            }

            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.fetchData()
        },
        onTabChange(key) {
            this.activeTab = key
            // 取回该 Tab 自己的报表统计时间，未初始化时按默认区间补齐
            if (!this.tabDateRange[key]) {
                this.$set(this.tabDateRange, key, this.defaultDateRange(key))
            }
            this.queryParam.date = this.tabDateRange[key]
            this.tableGrid.columns = this.currentColumns
            this.tableGrid.pagerConfig.currentPage = 1
            this.queryParam.sort_field = undefined
            this.queryParam.sort_type = undefined
            this.selectedCampaignRows = []
            this.selectedAdvertiserRows = []
            this.fetchData()
        },
        footerMethod({ columns }) {
            if (this.activeTab === 'campaign_list') {
                return []
            }

            const sums = []
            const currentSummary = this.activeTab === 'advertiser'
                ? this.summary
                : (this.activeTab === 'worker' ? this.workerSummary : this.campaignSummary)
            const sumFields = ['charge', 'photo_click', 'played_num', 'bclick', 'show', 'aclick', 'photo_click_ratio', 'action_ratio', 'impression_1k_cost', 'click_1k_cost', 'photo_click_cost', 'action_cost', 'aclick_ratio', 'conversion_num', 'conversion_num_cost', 'minigame_iaa_purchase_roi', 'minigame_iaa_purchase_amount', 'conversion_cost', 'activation', 'event_pay_purchase_amount', 'event_pay_roi', 'event_pay_first_day_roi', 'minigame_iaa_purchase_amount_three_day_by_conversion_roi', 'minigame_iaa_purchase_amount_week_by_conversion_roi', 'minigame_iaa_purchase_amount_15_day_by_conversion_roi', 'minigame_iaa_purchase_amount_30_day_by_conversion_roi', 'event_pay_purchase_amount_three_day_by_conversion_roi', 'event_pay_purchase_amount_week_by_conversion_roi', 'event_pay_purchase_amount_15_day_by_conversion_roi', 'event_pay_purchase_amount_30_day_by_conversion_roi', 'iaa_cumulative_roi_3d', 'iaa_cumulative_roi_7d', 'iaa_cumulative_roi_15d', 'iaa_cumulative_roi_30d', 'pay_cumulative_roi_3d', 'pay_cumulative_roi_7d', 'pay_cumulative_roi_15d', 'pay_cumulative_roi_30d']
            columns.forEach((column, columnIndex) => {
                if (columnIndex === 0) {
                    sums.push('合计')
                    return
                }

                // 多级表头：父列本身不渲染单元格，需为其子列逐个补值，保证合计与渲染列一一对应
                const fields = column.children && column.children.length > 0
                    ? column.children.map(child => child.field)
                    : [column.field]

                fields.forEach(field => {
                    if (field && sumFields.includes(field) && currentSummary[field] != null) {
                        sums.push(parseFloat(Number(currentSummary[field]).toFixed(2)))
                    } else {
                        sums.push('')
                    }
                })
            })
            return [sums]
        },
        changeOutId () {
            const inputValue = this.queryParam.advertiser_id;
            this.advertiser_ids = inputValue.replace(/,/g, '\n');
        },
        handleSelect({ records }) {
            if (this.activeTab === 'advertiser') {
                this.selectedAdvertiserRows = records
            } else {
                this.selectedCampaignRows = records
            }
        },
        async closeSingleCampaign(row) {
            this.$confirm({
                title: '确认关停',
                content: `确认暂停广告计划 ${row.campaign_id}（${row.campaign_name || ''}）？`,
                onOk: async () => {
                    await this.doClose([{ advertiser_id: row.advertiser_id, campaign_id: row.campaign_id, campaign_name: row.campaign_name }])
                }
            })
        },
        async batchCloseCampaigns() {
            if (this.selectedCampaignRows.length === 0) {
                this.$message.warning('请先选择要关停的广告计划')
                return
            }
            const items = this.selectedCampaignRows
                .filter(row => row.put_status === 1)
                .map(row => ({ advertiser_id: row.advertiser_id, campaign_id: row.campaign_id, campaign_name: row.campaign_name }))

            if (items.length === 0) {
                this.$message.warning('所选计划中没有投放中的计划')
                return
            }

            this.$confirm({
                title: '确认批量关停',
                content: `确认暂停 ${items.length} 个投放中的广告计划？`,
                onOk: async () => {
                    await this.doClose(items)
                }
            })
        },
        async doClose(items) {
            this.closeLoading = true
            try {
                const res = await closeCampaigns({ items })
                if (res.data.success && res.data.success.length > 0) {
                    this.$message.success(`成功提交 ${res.data.success.length} 个计划关停任务`)
                }
                if (res.data.errors && res.data.errors.length > 0) {
                    this.$message.error(`部分计划关停失败：${res.data.errors.join('; ')}`)
                }
                this.selectedCampaignRows = []
                this.fetchData()
            } catch (e) {
                this.$message.error('关停操作失败')
            } finally {
                this.closeLoading = false
            }
        },
        async enableSingleCampaign(row) {
            this.$confirm({
                title: '确认启用',
                content: `确认启用广告计划 ${row.campaign_id}（${row.campaign_name || ''}）？`,
                onOk: async () => {
                    await this.doEnable([{ advertiser_id: row.advertiser_id, campaign_id: row.campaign_id, campaign_name: row.campaign_name }])
                }
            })
        },
        async batchEnableCampaigns() {
            if (this.selectedCampaignRows.length === 0) {
                this.$message.warning('请先选择要启用的广告计划')
                return
            }
            const items = this.selectedCampaignRows
                .filter(row => row.put_status === 2)
                .map(row => ({ advertiser_id: row.advertiser_id, campaign_id: row.campaign_id, campaign_name: row.campaign_name }))

            if (items.length === 0) {
                this.$message.warning('所选计划中没有已暂停的计划')
                return
            }

            this.$confirm({
                title: '确认批量启用',
                content: `确认启用 ${items.length} 个已暂停的广告计划？`,
                onOk: async () => {
                    await this.doEnable(items)
                }
            })
        },
        async doEnable(items) {
            this.enableLoading = true
            try {
                const res = await enableCampaigns({ items })
                if (res.data.success && res.data.success.length > 0) {
                    this.$message.success(`成功提交 ${res.data.success.length} 个计划启用任务`)
                }
                if (res.data.errors && res.data.errors.length > 0) {
                    this.$message.error(`部分计划启用失败：${res.data.errors.join('; ')}`)
                }
                this.selectedCampaignRows = []
                this.fetchData()
            } catch (e) {
                this.$message.error('启用操作失败')
            } finally {
                this.enableLoading = false
            }
        },
        handleAdvertiserSelect({ records }) {
            this.selectedAdvertiserRows = records
        },
        async closeAllAdvertiserCampaignsForRow(row) {
            const advertiserId = row.advertiser_id
            const advertiserName = row.advertiser_name || ''
            try {
                const countRes = await getAdvertiserCampaignsCount({ advertiser_ids: advertiserId, put_status: 1 })
                const list = countRes.data.list || []
                const totalCount = list.reduce((sum, item) => sum + item.count, 0)
                if (totalCount === 0) {
                    this.$message.warning(`广告主 ${advertiserName}（${advertiserId}）下没有可关停的计划`)
                    return
                }
                this.$confirm({
                    title: '确认关停',
                    content: `确认关停广告主 ${advertiserName}（${advertiserId}）下所有计划（共 ${totalCount} 个）？`,
                    onOk: async () => {
                        await this.doCloseAllCampaigns([advertiserId])
                    }
                })
            } catch (e) {
                this.$message.error('查询计划数量失败')
            }
        },
        async batchCloseAdvertiserCampaigns() {
            if (this.selectedAdvertiserRows.length === 0) {
                this.$message.warning('请先选择要关停的广告主')
                return
            }
            const advertiserIds = this.selectedAdvertiserRows.map(row => row.advertiser_id)
            try {
                const countRes = await getAdvertiserCampaignsCount({ advertiser_ids: advertiserIds.join(','), put_status: 1 })
                const list = countRes.data.list || []
                const totalCount = list.reduce((sum, item) => sum + item.count, 0)
                if (totalCount === 0) {
                    this.$message.warning('所选广告主下没有可关停的计划')
                    return
                }
                this.$confirm({
                    title: '确认批量关停',
                    content: `确认关停 ${advertiserIds.length} 个广告主下所有计划（共 ${totalCount} 个）？`,
                    onOk: async () => {
                        await this.doCloseAllCampaigns(advertiserIds)
                    }
                })
            } catch (e) {
                this.$message.error('查询计划数量失败')
            }
        },
        async doCloseAllCampaigns(advertiserIds) {
            this.advertiserCloseLoading = true
            try {
                const res = await closeAllAdvertiserCampaigns({ advertiser_ids: advertiserIds })
                if (res.data.success_count > 0) {
                    this.$message.success(`成功提交 ${res.data.success_count} 个计划关停任务`)
                }
                if (res.data.errors && res.data.errors.length > 0) {
                    this.$message.error(`部分操作失败：${res.data.errors.join('; ')}`)
                }
                this.selectedAdvertiserRows = []
                this.fetchData()
            } catch (e) {
                this.$message.error('关停操作失败')
            } finally {
                this.advertiserCloseLoading = false
            }
        },
        async enableAllAdvertiserCampaignsForRow(row) {
            const advertiserId = row.advertiser_id
            const advertiserName = row.advertiser_name || ''
            try {
                const countRes = await getAdvertiserCampaignsCount({ advertiser_ids: advertiserId, put_status: 2 })
                const list = countRes.data.list || []
                const totalCount = list.reduce((sum, item) => sum + item.count, 0)
                if (totalCount === 0) {
                    this.$message.warning(`广告主 ${advertiserName}（${advertiserId}）下没有可启用的计划`)
                    return
                }
                this.$confirm({
                    title: '确认启用',
                    content: `确认启用广告主 ${advertiserName}（${advertiserId}）下所有计划（共 ${totalCount} 个）？`,
                    onOk: async () => {
                        await this.doEnableAllCampaigns([advertiserId])
                    }
                })
            } catch (e) {
                this.$message.error('查询计划数量失败')
            }
        },
        async batchEnableAdvertiserCampaigns() {
            if (this.selectedAdvertiserRows.length === 0) {
                this.$message.warning('请先选择要启用的广告主')
                return
            }
            const advertiserIds = this.selectedAdvertiserRows.map(row => row.advertiser_id)
            try {
                const countRes = await getAdvertiserCampaignsCount({ advertiser_ids: advertiserIds.join(','), put_status: 2 })
                const list = countRes.data.list || []
                const totalCount = list.reduce((sum, item) => sum + item.count, 0)
                if (totalCount === 0) {
                    this.$message.warning('所选广告主下没有可启用的计划')
                    return
                }
                this.$confirm({
                    title: '确认批量启用',
                    content: `确认启用 ${advertiserIds.length} 个广告主下所有计划（共 ${totalCount} 个）？`,
                    onOk: async () => {
                        await this.doEnableAllCampaigns(advertiserIds)
                    }
                })
            } catch (e) {
                this.$message.error('查询计划数量失败')
            }
        },
        async doEnableAllCampaigns(advertiserIds, putStatus = 1) {
            this.advertiserEnableLoading = true
            try {
                const res = await enableAllAdvertiserCampaigns({ advertiser_ids: advertiserIds, put_status: putStatus })
                if (res.data.success_count > 0) {
                    this.$message.success(`成功提交 ${res.data.success_count} 个计划启用任务`)
                }
                if (res.data.errors && res.data.errors.length > 0) {
                    this.$message.error(`部分操作失败：${res.data.errors.join('; ')}`)
                }
                this.selectedAdvertiserRows = []
                this.fetchData()
            } catch (e) {
                this.$message.error('启用操作失败')
            } finally {
                this.advertiserEnableLoading = false
            }
        },
        accessTo(route) {
            return this.$helper.accessTo('MediaAdvertiserStatController', route)
        },
    },
}
